module.exports = __webpack_public_path__ + "frontend/img/icon_info.aee990bd.svg";